import { serviceApi } from '~/features';
import { clearParams } from '~/shared';

export async function downloadCurrentProductList(params = {}) {
  const clearedParams = clearParams(params);
  const response = await serviceApi.get<Blob>(
    `CampanhaProdutosPatrocinados/export-excel?campanhaId=${params}`,
    {
      responseType: 'blob',
      params: clearedParams,
    }
  );
  return response;
}
